import { Component, HostListener, OnInit } from '@angular/core';

import { DataService } from '@data/data.service';

@Component({
  selector: 'app-web-synapse',
  templateUrl: './web-synapse.component.html',
  styleUrls: ['./web-synapse.component.scss'],
})
export class WebSynapseComponent implements OnInit {
  constructor(public dataService: DataService) {}

  ngOnInit() {}

  @HostListener('window:resize', ['$event'])
  onResize(_event) {
    this.dataService.windowInnerHeight.next(window.innerHeight);
  }
}
